import { connect } from 'react-redux';
import { prop, path, always, pipe, ifElse, isNil, evolve, merge, pick, head, split, map as map$1, uniq, flip, __, assoc, pathOr, compose, invoker, unless, defaultTo, partial, reject, tryCatch, when, isEmpty } from 'ramda';
import { createSelector } from 'reselect';
import { renameKeys, isNotNil, dispatch, ensureArray } from 'ramda-adjunct';
import { createAction } from 'redux-actions';
import { combineReducers } from 'redux';
import { createReducer } from 'redux-create-reducer';
import * as cookies from 'browser-cookies';
import { dispatchEvent } from '@ux/tagmg';
import { createEpic, promises } from '@ux/fabric';
import { combineEpics, select } from 'redux-most';
import { ignoreElements } from 'most-adjunct';
import { map as map$2, tap, filter } from 'mostc';
import { json, jsonRpc, fetch } from '@ux/drivers';

var REDUCER_MOUNT_POINT = 'whitelabel';
var EXPERIMENT_COOKIE_KEY = 'bpt_experiment_id';
var BRAND_ID_COOKIE = 'brand_id';
var MARKET_COOKIE = 'market';
var SEED_COOKIE = 'bpt_Seed';
var DEFAULT_BRAND_API_URL = 'https://dev.brand-pilot.heg-cp.com';
var COOKIE_LIFESPAN = 30;

/* global BASE_URLS */
var getState = prop(REDUCER_MOUNT_POINT);
var getAllConfigs = createSelector(getState, path(['appConfig', 'data'])); // eslint-disable-next-line max-len

var getAppConfig = function getAppConfig(app) {
  return createSelector(getAllConfigs, prop(app));
}; // eslint-disable-next-line max-len

var getBrandConfig = getAppConfig('brand');
var getFixedTheme = always({
  palette: {
    headerBackground: '#777',
    headerForeground: '#505050',
    headerHighlight: '',
    primary: '#505050',
    primaryContrast: '',
    primaryGradient: '#505050',
    secondary: '#505050',
    tertiary: '#777',
    highlight: '',
    highlightContrast: '',
    accent: '#505050',
    contrast: '#fff',
    contrastAccent: '#fff',
    cta: '',
    ctaContrast: '',
    illustrations: {
      primary: '',
      primaryContrast: '',
      secondary: '',
      secondaryContrast: '',
      tertiary: '',
      tertiaryContrast: ''
    },
    grey01: '#1a1a1a',
    grey02: '#282828',
    grey03: '#333',
    grey04: '#484848',
    grey05: '#666',
    grey06: '#848484',
    grey07: '#909090',
    grey08: '#999',
    grey09: '#ccc',
    grey10: '#eee',
    grey11: '#f2f2f2',
    grey12: '#f7f7f7',
    red01: '#cc0000',
    red02: '#f4c7c7',
    yellow01: '#EDD000',
    yellow02: '#FAF1B2',
    green01: '#7fa800',
    green02: '#d8e5b2'
  },
  typography: {
    content: 'Arial, sans-serif',
    display: 'Arial, sans-serif',
    contentURL: null,
    displayURL: null,
    sizing: 1
  },
  brandLogos: {
    logoLight: '',
    logoDark: '',
    logoContrast: ''
  },
  curvature: 0,
  spacing: 0,
  iconSet: ''
});
var getTheme = createSelector(getBrandConfig, getFixedTheme, function (appConfig, fixedTheme) {
  return pipe(prop('theme'), ifElse(isNil, always(fixedTheme), evolve({
    palette: merge(fixedTheme.palette)
  })))(appConfig);
});
var isThemeLoaded = createSelector(getState, path(['appConfig', 'isLoaded']));
var getAssets = createSelector(getBrandConfig, prop('assets'));
var getUrls = createSelector(getBrandConfig, prop('urls'));
var getBrandLogos = createSelector( // @ts-ignore
getAssets, pipe(prop('brandLogos'), pick(['logoLight', 'logoDark', 'logoContrast']), renameKeys({
  logoLight: 'light',
  logoDark: 'dark',
  logoContrast: 'contrast'
})));
var getMessages = path(['language', 'messages']);
var getBrandId = createSelector(getState, path(['brand', 'id']));
var getBrandBaseUrl = createSelector(getBrandId, function (brandId) {
  return "".concat(BASE_URLS.BRAND_API, "/").concat(brandId);
});
var getMarket = createSelector(getState, path(['locale', 'market']));
var getLocales = createSelector(getState, path(['locale', 'locales']));
var getLocale = createSelector(getLocales, head);
var extractLocaleCode = pipe(split('-'), head);
var getLooseLocales = createSelector(getLocales, pipe(map$1(extractLocaleCode), uniq));
var getLooseLocale = createSelector(getLooseLocales, head);

var index = /*#__PURE__*/Object.freeze({
  getAppConfig: getAppConfig,
  getBrandConfig: getBrandConfig,
  getFixedTheme: getFixedTheme,
  getTheme: getTheme,
  isThemeLoaded: isThemeLoaded,
  getAssets: getAssets,
  getUrls: getUrls,
  getBrandLogos: getBrandLogos,
  getMessages: getMessages,
  getBrandId: getBrandId,
  getBrandBaseUrl: getBrandBaseUrl,
  getMarket: getMarket,
  getLocales: getLocales,
  getLocale: getLocale,
  getLooseLocales: getLooseLocales,
  getLooseLocale: getLooseLocale
});

var pathIn = flip(path);

var withAppConfig = function withAppConfig(app) {
  var paths = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return connect(function (state) {
    var data = getAppConfig(app)(state);
    return map$1(pathIn(data), // @ts-ignore
    paths);
  });
};

var prefix = '@@ux/whitelabel/S_';
var LOAD_APP_CONFIG = "".concat(prefix, "LOAD_APP_CONFIG");
var LOAD_BRAND_ID = "".concat(prefix, "LOAD_BRAND_ID");
var loadAppConfig = createAction(LOAD_APP_CONFIG);
var loadBrandId = createAction(LOAD_BRAND_ID);

var index$1 = /*#__PURE__*/Object.freeze({
  LOAD_APP_CONFIG: LOAD_APP_CONFIG,
  LOAD_BRAND_ID: LOAD_BRAND_ID,
  loadAppConfig: loadAppConfig,
  loadBrandId: loadBrandId
});

var prefix$1 = '@@ux/whitelabel/M_';
var APP_CONFIG_REQUEST = "".concat(prefix$1, "/M_APP_CONFIG_REQUEST");
var APP_CONFIG_SUCCESS = "".concat(prefix$1, "/M_APP_CONFIG_SUCCESS");
var APP_CONFIG_FAILURE = "".concat(prefix$1, "/M_APP_CONFIG_FAILURE");
var BRAND_ID_LOADED = "".concat(prefix$1, "/M_BRAND_ID_LOADED");
var MARKET_LOADED = "".concat(prefix$1, "/M_MARKET_LOADED");
var LOCALE_LOADED = "".concat(prefix$1, "/M_LOCALE_LOADED");
var appConfigRequest = createAction(APP_CONFIG_REQUEST);
var appConfigSuccess = createAction(APP_CONFIG_SUCCESS, function (config) {
  return config;
});
var appConfigFailure = createAction(APP_CONFIG_FAILURE);
var brandIdLoaded = createAction(BRAND_ID_LOADED, function (brandId) {
  return {
    brandId: brandId
  };
});
var marketLoaded = createAction(MARKET_LOADED, function (market) {
  return {
    market: market
  };
});
var localeLoaded = createAction(LOCALE_LOADED, function (locales) {
  return {
    locales: locales
  };
});

var index$2 = /*#__PURE__*/Object.freeze({
  APP_CONFIG_REQUEST: APP_CONFIG_REQUEST,
  APP_CONFIG_SUCCESS: APP_CONFIG_SUCCESS,
  APP_CONFIG_FAILURE: APP_CONFIG_FAILURE,
  BRAND_ID_LOADED: BRAND_ID_LOADED,
  MARKET_LOADED: MARKET_LOADED,
  LOCALE_LOADED: LOCALE_LOADED,
  appConfigRequest: appConfigRequest,
  appConfigSuccess: appConfigSuccess,
  appConfigFailure: appConfigFailure,
  brandIdLoaded: brandIdLoaded,
  marketLoaded: marketLoaded,
  localeLoaded: localeLoaded
});

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var _createReducer;
var initialState = {
  isFetching: false,
  isLoaded: false,
  error: null,
  data: null
};
var appConfig = createReducer(initialState, (_createReducer = {}, _defineProperty(_createReducer, APP_CONFIG_REQUEST, merge(__, {
  isFetching: true,
  isLoaded: false
})), _defineProperty(_createReducer, APP_CONFIG_SUCCESS, function (state, action) {
  return merge(state, {
    isFetching: false,
    isLoaded: true,
    error: null,
    data: action.payload.apps
  });
}), _defineProperty(_createReducer, APP_CONFIG_FAILURE, function (state, action) {
  return merge(state, {
    isFetching: false,
    isLoaded: false,
    error: action.payload,
    data: null
  });
}), _createReducer));

var initialState$1 = {
  id: ''
};
var brand = createReducer(initialState$1, _defineProperty({}, BRAND_ID_LOADED, function (state, action) {
  return assoc('id', action.payload.brandId, state);
}));

var _createReducer$1;
var initialState$2 = {
  market: null,
  locales: ['en']
};
var locale = createReducer(initialState$2, (_createReducer$1 = {}, _defineProperty(_createReducer$1, MARKET_LOADED, function (state, action) {
  return assoc('market', action.payload.market, state);
}), _defineProperty(_createReducer$1, LOCALE_LOADED, function (state, action) {
  return assoc('locales', action.payload.locales, state);
}), _createReducer$1));

var index$3 = combineReducers({
  appConfig: appConfig,
  brand: brand,
  locale: locale
});

var appConfigEpic = function appConfigEpic(getAppConfig, getBrandId, getExperiment, seeder, getMarket, getLocales) {
  return function (keys) {
    return createEpic({
      signal: LOAD_APP_CONFIG,
      pending: always(appConfigRequest()),
      process: function process() {
        var brandId = getBrandId();
        var experiment = getExperiment();
        var seed = seeder.get();
        return getAppConfig(brandId, keys, experiment, seed);
      },
      onSuccess: function onSuccess(config) {
        var market = getMarket();
        var locales = getLocales();
        return [marketLoaded(market), localeLoaded(locales), appConfigSuccess(config)];
      },
      onFailure: appConfigFailure
    });
  };
};
var appConfigSuccessEpic = function appConfigSuccessEpic(saveExperiment, dispatchEvent) {
  return pipe(select(APP_CONFIG_SUCCESS), map$2(pathOr(null, ['payload', 'meta', 'experiment'])), tap(saveExperiment), filter(isNotNil), tap(function (experiment) {
    dispatchEvent({
      event: 'experimentAssigned',
      experimentId: experiment.externalId,
      experimentVariant: experiment.variant
    });
  }), ignoreElements);
};
var brandIdEpic = function brandIdEpic(getBrandId) {
  return createEpic({
    signal: LOAD_BRAND_ID,
    process: getBrandId,
    onSuccess: brandIdLoaded
  });
};
var _epics = (function (getAppConfig, getBrandId, getExperiment, seeder, getMarket, getLocales, saveExperiment, dispatchEvent) {
  var partialEpics = combineEpics([appConfigSuccessEpic(saveExperiment, dispatchEvent), brandIdEpic(getBrandId)]);
  var createAppConfigEpic = appConfigEpic(getAppConfig, getBrandId, getExperiment, seeder, getMarket, getLocales);
  return function (keys) {
    return combineEpics([partialEpics, createAppConfigEpic(keys)]);
  };
});

var createDriver = compose(json(), jsonRpc());
var driver = (function () {
  return createDriver(fetch);
});

var parse = invoker(1, 'parse')(__, JSON);
var stringify = invoker(1, 'stringify')(__, JSON); // @ts-ignore

var pickRelevant = unless(isNil, pick(['id', 'variant']));
var getExperiment = function getExperiment(cookies) {
  return function () {
    return pipe(cookies.get, defaultTo(null), parse, pickRelevant)(EXPERIMENT_COOKIE_KEY);
  };
};
var saveExperiment = function saveExperiment(cookies) {
  return function (experiment) {
    pipe(pickRelevant, stringify, partial(cookies.set, [EXPERIMENT_COOKIE_KEY]))(experiment);
  };
};

var map = promises.map,
    mapRej = promises.mapRej;

var createKey = function createKey(brandId, keys) {
  return "bpt_".concat(brandId, "_").concat(keys.join('_'));
};

var getAppConfig$1 = function getAppConfig(driver, session, getBrandApiUrl, getUserAgent, getReferrer, window) {
  return function (brandId, keys, experiment, seed) {
    var key = createKey(brandId, keys); // temporarily disable caching

    var getConfigFromCache = function getConfigFromCache(key) {
      return new Promise(function (resolve, reject) {
        // session.get(key)
        reject(null);
      });
    };

    var getConfigFromApi = function getConfigFromApi() {
      var url = getBrandApiUrl();
      var userAgent = getUserAgent();
      var referrer = getReferrer();
      var data = {
        brandId: brandId,
        keys: keys,
        userAgent: userAgent,
        referrer: referrer,
        experiment: experiment,
        seed: seed,
        messages: false,
        location: pick(['hash', 'host', 'hostname', 'href', 'origin', 'pathname', 'port', 'protocol', 'search'])(window.location)
      };
      var request = {
        url: url,
        method: 'v1.getMultiConfig',
        data: reject(isNil, data)
      };
      return pipe(driver, map(function (result) {
        session.set(key, result);
        return result;
      }))(request);
    };

    return pipe(getConfigFromCache, mapRej(getConfigFromApi))(key);
  };
};

var getBrandApiUrl = tryCatch(function () {
  return BRAND_API_URL;
}, always(DEFAULT_BRAND_API_URL));

var getBrandId$1 = function getBrandId(cookies) {
  return function () {
    return cookies.get(BRAND_ID_COOKIE);
  };
};

var getLocales$1 = function getLocales(window) {
  return function () {
    return pipe(prop('navigator'), // @ts-ignore - dispatch is not correctly typed
    dispatch([prop('languages'), prop('language'), prop('browserLanguage'), always('en')]), ensureArray, when(isEmpty, always(['en'])))(window);
  };
};

var getMarket$1 = function getMarket(cookies) {
  return function () {
    return cookies.get(MARKET_COOKIE);
  };
};

var getReferrer = function getReferrer(document) {
  return function () {
    return document.referrer;
  };
};

var getUserAgent = function getUserAgent(window) {
  return function () {
    return pathOr('', ['navigator', 'userAgent'], window);
  };
};

var generate = function generate() {
  return Math.floor(Math.random() * 65536);
};
var set = function set(cookies) {
  return function (seed) {
    cookies.set(SEED_COOKIE, seed.toString(), {
      expires: COOKIE_LIFESPAN
    });
  };
};
var get = function get(cookies, set, generate) {
  return function () {
    var value = cookies.get(SEED_COOKIE);

    if (!value) {
      value = generate();
      set(value);
    }

    return Number(value);
  };
};

var seed = function seed(cookies) {
  var _set = set(cookies);

  var _get = get(cookies, _set, generate);

  return {
    set: _set,
    get: _get
  };
};

var parse$1 = invoker(1, 'parse')(__, JSON);

var session = function session(window) {
  return {
    get: pipe(function (key) {
      return window.sessionStorage.getItem(key);
    }, tryCatch(parse$1, always(null))),
    set: function set(key, value) {
      window.sessionStorage.setItem(key, JSON.stringify(value));
    }
  };
};

var composite = (function () {
  var driver$1 = driver();

  var session$1 = session(window);

  var getUserAgent$1 = getUserAgent(window);

  var getReferrer$1 = getReferrer(document);

  var getBrandApiUrl$1 = getBrandApiUrl;

  var getAppConfig = getAppConfig$1(driver$1, session$1, getBrandApiUrl$1, getUserAgent$1, getReferrer$1, window);

  var getBrandId = getBrandId$1(cookies);

  var getExperiment$1 = getExperiment(cookies);

  var saveExperiment$1 = saveExperiment(cookies);

  var getMarket = getMarket$1(cookies);

  var getLocales = getLocales$1(window);

  var seed$1 = seed(cookies);

  var epics = _epics(getAppConfig, getBrandId, getExperiment$1, seed$1, getMarket, getLocales, saveExperiment$1, dispatchEvent);

  return {
    epics: epics
  };
});

var _composite = composite(),
    epics = _composite.epics;

export { REDUCER_MOUNT_POINT, epics, index$2 as messages, index$3 as reducer, index as selectors, index$1 as signals, withAppConfig };
